export default __webpack_public_path__ + "static/media/Kyle-eggelhoefer.f1b36a2a.png";